import { useEffect, useRef } from 'react'
import debounce from 'lodash.debounce'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { setSearchQuery } from '../../../store/navigation'
import { useForm } from 'react-hook-form'
import {classNames, getQueryParam} from '../Helpers'

export default function Search({ title, classes = 'mt-3 mb-6' }) {

    const dispatch = useDispatch()
    const history = useHistory()
    const { searchQuery } = useSelector(state => state.navigation)
    const searchRef = useRef()

    const { register, reset } = useForm({ search: searchQuery })

    const debouncedSearch = debounce(nextQuery => {
        dispatch(setSearchQuery(nextQuery))

        if (history) {
            history.replace({ 'search': getQueryParam(nextQuery) })
        }
    }, 300)

    function handleSearch(e) {
        debouncedSearch(e.target.value)
    }

    useEffect(() => {
        reset({ search: searchQuery })
    }, [searchQuery])

    useEffect(() => {
        return () => {
            dispatch(setSearchQuery(''))
        }
    }, [])

    return (
        <div className={classNames("relative flex items-center", classes)}>
            <input
                ref={searchRef}
                type="text"
                name="search"
                id="search"
                defaultValue={searchQuery}
                placeholder={"Search " + title}
                className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full pr-12 sm:text-md border-gray-300 rounded-md"
                onChange={handleSearch}
            />
            <div className="absolute inset-y-0 right-0 flex py-2.5 pr-2.5">
                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
            </div>
        </div>
    )
}